import { alpha } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

const brandLockupSizes = {
  default: {
    logo: {
      width: 124,
      height: 32,
    },
    titleFontSize: {
      xs: "1.9rem",
      md: "2.2rem",
    },
  },
  compact: {
    logo: {
      width: 96,
      height: 26,
    },
    titleFontSize: {
      xs: "1.7rem",
      md: "1.9rem",
    },
  },
} as const;

const getBrandLockupSize = (compact: boolean) => (compact ? brandLockupSizes.compact : brandLockupSizes.default);

export const brandLockupRootSx: SxProps<Theme> = {
  minWidth: 0,
};

export const brandLockupLogoImageSx: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
  objectPosition: "left center",
};

export const brandLockupTextWrapperSx: SxProps<Theme> = {
  minWidth: 0,
};

export const getBrandLockupLogoSx = (theme: Theme, compact: boolean, inverted: boolean): SystemStyleObject<Theme> => {
  const { logo } = getBrandLockupSize(compact);

  return {
    ...logo,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    filter: `drop-shadow(0 6px 14px ${alpha(
      inverted ? theme.palette.common.black : theme.palette.primary.main,
      inverted ? 0.22 : 0.12,
    )})`,
  };
};

export const getBrandLockupTitleSx = (compact: boolean, hideOnMobile = false): SxProps<Theme> => ({
  display: hideOnMobile ? { xs: "none", sm: "block" } : "block",
  fontSize: getBrandLockupSize(compact).titleFontSize,
  lineHeight: 1,
  whiteSpace: "nowrap",
});
